// Copyright 2025 Northern.tech AS
//
//    Licensed under the Apache License, Version 2.0 (the "License");
//    you may not use this file except in compliance with the License.
//    You may obtain a copy of the License at
//
//        http://www.apache.org/licenses/LICENSE-2.0
//
//    Unless required by applicable law or agreed to in writing, software
//    distributed under the License is distributed on an "AS IS" BASIS,
//    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//    See the License for the specific language governing permissions and
//    limitations under the License.
export const defaultRefreshDeploymentsLength = 30000;

// Landroval group-centric dynamic deployments.
// A dynamic deployment standing for a group is named `dyngroup:<group>` so the dedicated
// "Dynamic Groups" view can collect and group them by their target group.
export const DYNAMIC_GROUP_DEPLOYMENT_PREFIX = 'dyngroup:';

// Synthetic group representing every accepted device that is NOT assigned to any named
// inventory group (the complement, expressed as a `$nin` predicate over the other group names).
export const DEFAULT_DYNAMIC_GROUP = 'Default';
